import { useEffect, useState } from "react";
import StarRating from "../PoojaComponent/PoojaStarComponent";
import { getPoojaReview } from "@/pages/api";
import Pagination from "../pagination/Pagination";

const PoojaReview = ({ poojaData }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const recordsPerPage = 3;

  const nPages = Math.ceil(totalItems / recordsPerPage);

  useEffect(() => {
    (async () => {
      try {
        const response = await getPoojaReview(
          poojaData,
          currentPage,
          recordsPerPage
        );
        if (response.status === 200) {
          if (
            response.data &&
            response.data.statusCode === 200 &&
            Array.isArray(response.data.body)
          ) {
            setReviews(response.data);
            setTotalItems(response.data.totalCount);
            setLoading(false);
          } else {
            setError(true);
            setLoading(false);
          }
        } else {
          setError(true);
          setLoading(false);
        }
      } catch (error) {
        setError("Error fetching reviews: " + error.message);
        setLoading(false);
      }
    })();
  }, [poojaData, currentPage, recordsPerPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="flex px-6 md:px-0 flex-col justify-start md:gap-2 pt-10 pb-6">
        <h3 className="text-base md:text-xl font-medium text-Default leading- tracking-wide">
          Reviews
        </h3>

        {Array.isArray(reviews.body) && reviews.body.length > 0 ? (
          <>
            <div className="flex flex-row gap-4 pt-1 pb-2">
              <StarRating rating={4} layout="responsive" />
              <p className="text-[#94a3b8] text-xs shrink-0 leading-5 pt-0.5">
                reviews{" "}
                <span className="font-semibold text-Default">
                  {reviews.totalCount}
                </span>
              </p>
            </div>
            {reviews.body.map((review) => (
              <div key={review._id} className="py-2 flex flex-col gap-1">
                <h3 className="text-sm font-medium text-Default">
                  {review.user.length > 0 ? review.user[0].userName : "User"}
                </h3>
                <div className="flex flex-row justify-start items-start text-Default text-xs leading-6 tracking-0">
                  <span className="flex flex-row items-center justify-start gap-4">
                    Reviewed on{" "}
                    {new Date(review.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                    <StarRating rating={review.rating} layout="responsive" />
                  </span>
                </div>
                <p className="text-sm text-Default tracking-0 leading-5 text-justify">
                  {review.comment}
                </p>
              </div>
            ))}
            <div className="flex flex-row justify-end items-center font-bastoni text-4xl text-Default px-1">
              <Pagination
                nPages={nPages}
                currentPage={currentPage}
                setCurrentPage={handlePageChange}
              />
            </div>
          </>
        ) : (
          error && <div>No reviews available</div>
        )}
      </div>
    </>
  );
};

export default PoojaReview;
